"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import _ from "lodash";
import { AccountSessionMixins } from "@/service/account-session";
import OpenBill from "@/views/costItems/components/dialog/OpenBill.vue";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import UiDialog from "@/components/dialog/UiDialog.vue";
import DateFormat from "@/framework/timeformatter";
import { OrderDetailModel } from "@/models/costModels/OrderDetail.model";
import OrderSearch from "./search/OrderSearchForm.vue";
import { UiFormController } from "@/components/form/UiForm.vue";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import Question from "@/components/Question.vue";
import { Debounce } from "vue-debounce-decorator";
class FormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.operator_name = null;
    this.expiryDate = [];
    this.order_no = null;
    this.should_pay_coin = 0;
    this.invoice_status_desc = 2;
    this.pay_platform = null;
    this.use_discount_coupon = 0;
  }
}
let OrderManage = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v8/client/orders")
    );
    this.formcontroller = new FormController();
    this.OrderDetail = new OrderDetailModel();
    this.OrderGuid = "";
    this.Detailcontrol = null;
    this.openBill_show = true;
    this.multipleBillSelection = [];
    this.searchStr = "";
    this.searchDate = [
      new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1e3 * 24 * 7),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1)
    ];
    this.searchStr_dates = null;
    this.searchDate_dates = null;
    this.showSearchName = true;
    this.searchData = "";
    this.searchParams = {
      search: {},
      select: null
    };
    this.pickerOptions = {
      shortcuts: [
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.today"),
          onClick(picker) {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1);
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(new Date(start.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.toLocaleDateString()).getTime() - 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(new Date(end.toLocaleDateString()).getTime());
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thisweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() - 1) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastsevenday"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 7);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastweek"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (start.getDay() + 6) * 3600 * 1e3 * 24);
            start.setHours(0, 0, 0, 0);
            end.setTime(end.getTime() + (0 - end.getDay()) * 3600 * 1e3 * 24);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.thismonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.setDate(1));
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastthirtydays"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1e3 * 24 * 30);
            start.setHours(0, 0, 0, 0);
            picker.$emit("pick", [start, end]);
          }
        },
        {
          // text: this.$t("loginlogs.nearweeks"),
          text: this.$t("loginlogs.lastmonth"),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(new Date(start.setMonth(start.getMonth() - 1)).setDate(1));
            start.setHours(0, 0, 0, 0);
            end.setTime(end.setDate(1));
            picker.$emit("pick", [start, end]);
          }
        }
      ],
      disabledDate(time) {
        return time.getTime() > new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1e3 - 1) || time.getTime() < new Date(new Date().setMonth(new Date().getMonth() - 12));
      }
    };
    this.orderStatistics = {
      // 订单数
      order_count: 0,
      // 实际金额
      should_pay_money: {
        cny: 0,
        usd: 0
      },
      // 使用鲸豆数
      should_pay_coin: {
        cny: 0,
        usd: 0
      },
      // 订单金额
      order_original_amount: {
        cny: 0,
        usd: 0
      },
      // 优惠金额
      order_discount_amount: {
        cny: 0,
        usd: 0
      }
    };
    this.searchByName = _.debounce((searchStr) => {
      if (searchStr !== null && searchStr !== "") {
        this.searchStr_dates = {
          operator_name: searchStr
        };
        this.searchAllData();
        return;
      }
      if (searchStr === null || searchStr === "") {
        this.searchStr_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchByDate = _.debounce((searchDate) => {
      if (searchDate !== null && searchDate.length !== 0) {
        let mintime = Date.parse(searchDate[0]);
        let maxtime = Date.parse(searchDate[1]);
        this.searchDate_dates = {
          start_time: mintime,
          end_time: maxtime
        };
        this.searchAllData();
        return;
      }
      if (searchDate === null || searchDate.length === 0) {
        this.searchDate_dates = null;
        this.searchAllData();
      }
    }, 500);
    this.searchAllData = _.debounce(() => {
      this.gridController.query.current = 1;
      this.searchParams = {
        search: {},
        select: null
      };
      if (this.searchDate_dates !== null) {
        this.searchParams.search = this.searchDate_dates;
        if (this.searchStr_dates !== null) {
          let obj = __spreadValues(__spreadValues({}, this.searchDate_dates), this.searchStr_dates);
          this.searchParams.search = obj;
        }
      }
      if (this.searchDate_dates === null) {
        this.searchParams = {
          search: {},
          select: null
        };
        if (this.searchStr_dates !== null) {
          this.searchParams.search = this.searchStr_dates;
        }
      }
      this.gridController.query.params = this.searchParams;
      this.gridController.search();
      this.checkRealOrderStatistics();
    }, 500);
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.searchByDate(this.searchDate);
    });
  }
  openBill() {
    if (this.openBill_show) {
      this.$message.error(this.$t("order.please_select_order_with_actual_payment"));
      return;
    }
    this._OpenBill.open();
  }
  // 总览时间
  get displayTimeRange() {
    return this.gridController.query.params && this.gridController.query.params.search && this.gridController.query.params.search.start_time && this.gridController.query.params.search.end_time ? `${this.dateFormatterDay(this.gridController.query.params.search.start_time)} - ${this.dateFormatterDay(this.gridController.query.params.search.end_time)}` : null;
  }
  dateFormatterDay(time) {
    return DateFormat.dateformatterDay(time);
  }
  transformOrderType(type) {
    if (type === "new_purchase") {
      return this.$i18n.t("order.order_type_new_purchase");
    }
    if (type === "renew_purchase") {
      return this.$i18n.t("order.order_type_renew_purchase");
    }
    return "-";
  }
  cancleOrder() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.auth/api/v7/orders/cancelUnpaidOrders`);
        this.$message.success(this.$t("order.operation_successful"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  checkRealOrderStatistics() {
    return __async(this, null, function* () {
      try {
        const searchParams = this.gridController.query.params.search;
        const response = yield API.get(`api://base.auth/api/v8/client/orders/statistics`, {
          params: {
            search: searchParams
          }
        });
        this.orderStatistics = response.data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      yield this.gridController.search();
      yield this.checkRealOrderStatistics();
    });
  }
  exportList() {
    return __async(this, null, function* () {
      try {
        yield UiConfirm.confirm(this.$t("export_tip.export_info_content"), this.$t("export_tip.export_info_title"), {
          cancelButtonText: this.$t("export_tip.export_cancel"),
          confirmButtonText: this.$t("export_tip.export_confirm")
        });
        this.$message.success(this.$t("order.export_info"));
        const exportWin = window.open("", "_self");
        const response = yield API.get(`api://base.auth/api/v7/export/orders`, {
          params: {
            page: this.gridController.query.current,
            size: this.gridController.query.size,
            sort: this.gridController.query.sort,
            search: this.gridController.query.params.search
          }
        });
        exportWin.location.href = response.data.download;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  clearDrawer() {
    this.formcontroller = new FormController();
    this.gridController.query.params = {
      search: {},
      select: null
    };
  }
  searchQuery(query) {
    return __async(this, null, function* () {
      this.searchParams = {
        search: {},
        select: null
      };
      this.searchParams.search = query.params;
      this.gridController.query.params = this.searchParams;
      this.gridController.query.current = 1;
      yield this.gridController.search();
      yield this.checkRealOrderStatistics();
    });
  }
  showRightDrawer() {
    return __async(this, null, function* () {
      yield this.clearSearch();
      const _advancedSearchForm = OrderSearch.create(this.formcontroller);
      _advancedSearchForm.$on("search", this.searchQuery);
      _advancedSearchForm.show();
    });
  }
  clearSearch() {
    return __async(this, null, function* () {
      if (this.searchStr !== null && this.searchStr !== "" || this.searchDate !== null && this.searchDate.length > 0) {
        this.searchStr = "";
        this.searchDate = [];
        this.clearDrawer();
        yield this.gridController.search();
        yield this.checkRealOrderStatistics();
      }
    });
  }
  selectEnable(row, rowIndex) {
    if (row.can_invoice) {
      if (row.invoice_status === 0 || row.invoice_status === 3) {
        if (row.consume === "\uFFE50.0" || row.consume === "$0.0") {
          return false;
        }
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  closeDetail() {
    this.Detailcontrol = null;
  }
  handleSelectionBill(items) {
    if (items.length > 0) {
      this.openBill_show = false;
    }
    if (items.length <= 0) {
      this.openBill_show = true;
    }
    this.multipleBillSelection = items;
  }
  ShowOrders(item) {
    return __async(this, null, function* () {
      try {
        this.OrderGuid = item.guid;
        let response = yield API.get(
          `api://base.auth/api/v7/orders/${item.guid}`
        );
        this.OrderDetail = response.data.order;
        if (this.OrderDetail.model !== "vd.upgrade.order.detail" && this.OrderDetail.model !== "coin.order.detail" && this.OrderDetail.model !== "traffic.order.detail" && this.OrderDetail.model !== "phone.order.model" && this.OrderDetail.model !== "cd.order.model") {
          this.Detailcontrol = new GridController(
            new APIDataSource(`api://base.auth/api/v7/orders/${item.guid}/vds`)
          );
          this.Detailcontrol.pagePosition = "dialog";
          this.Detailcontrol.search();
        }
        if (this.OrderDetail.model === "phone.order.model" || this.OrderDetail.model === "cd.order.model") {
          this.Detailcontrol = new GridController(
            new APIDataSource(`api://base.auth/api/v7/orders/${item.guid}/apps`)
          );
          this.Detailcontrol.pagePosition = "dialog";
          this.Detailcontrol.search();
        }
        this.OrderDialog.show();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  formate_create_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformat(DateFormat.check(time));
    }
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  goHelp(no) {
    window.open(`https://www.kuajingvs.com/help2/${no}`);
  }
  orderPay(order) {
    return __async(this, null, function* () {
      try {
        const response = yield API.post(
          `api://base.auth/api/v1/order-pay/${order.guid}`
        );
        let payment_way = response.data.order.pay_platform_code;
        let _style = response.data.order.order_type_action;
        if (_style !== "coin") {
          this.$router.push({
            name: "PaymentConfirmation",
            query: {
              t: response.data.order.pay_platform_code,
              r: "",
              id: order.guid,
              qr: response.data.url,
              gift: JSON.stringify(response.data.order.pay_money <= 0),
              style: _style
            }
          });
          if (payment_way === "payssion.alipay" || payment_way === "payssion.wechat" || payment_way === "paypal") {
            if (response.data.url) {
              let url_data = JSON.parse(response.data.url);
              let url = url_data.url;
              window.open(url, "_blank");
            }
          }
        } else {
          this.$router.push({
            name: "PaymentConfirmation",
            query: {
              t: response.data.order.pay_platform_code,
              jump: "",
              id: order.guid,
              qr: response.data.url,
              style: _style
            }
          });
          if (payment_way === "payssion.alipay" || payment_way === "payssion.wechat" || payment_way === "paypal") {
            if (response.data.url) {
              let url_data = JSON.parse(response.data.url);
              let url = url_data.url;
              window.open(url, "_blank");
            }
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("order-detail-dialog")
], OrderManage.prototype, "OrderDialog", 2);
__decorateClass([
  Ref("open-bill-dialog")
], OrderManage.prototype, "_OpenBill", 2);
__decorateClass([
  Debounce(500)
], OrderManage.prototype, "openBill", 1);
OrderManage = __decorateClass([
  Component({
    components: {
      OpenBill,
      UiDialog,
      UiGrid,
      Question
    }
  })
], OrderManage);
export {
  OrderManage as default
};
